<template>
  <div class="max-height-box" v-auto-height:maxHeight='-50' :max-height="maxHeight" :style="{'max-height': maxHeight + 'px', 'overflow': 'scroll', 'min-height': '150px'}">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'KtMaxHeight',
    data() {
      return {
        maxHeight: 0
      }
    }
  }
</script>
